'use client';

import { copy } from '@/data/copy';
import BackToPreviousPage from '@/components/utils/BackToPreviousPage';
import BWTHLogoWithBlueBackground from '@/components/utils/BWTHLogoWithBlueBackground';
import FinishLoggedSessionButton from '@/components/utils/FinishLoggedSessionButton';

export default function NotFound() {
  return (
    <div className="flex dark:bg-boxdark-2 dark:text-bodydark min-h-svh">
      <div className="flex flex-col content-center w-full">
        <div className="flex flex-col items-center space-y-4 justify-center h-full p-5">
          <BWTHLogoWithBlueBackground />

          <h2 className="mt-12 text-3xl font-semibold">
            {copy.pages.notFound.pageNotFound}
          </h2>
          <p className="text-gray-500">
            {copy.pages.notFound.pageNotFoundDescription}
          </p>

          <BackToPreviousPage />

          <p className="text-gray-500">
            {copy.pages.notFound.finishSessionDescription}
          </p>

          <FinishLoggedSessionButton />
        </div>
      </div>
    </div>
  );
}
